
import "bootstrap/dist/css/bootstrap.min.css"
import 'App.css'
import Routes from "Routes"
import VLibras from "@djpfs/react-vlibras"

import Stack from "react-bootstrap/Stack"
import Header from "components/Header"
import Footer from "components/Footer"

function App()
{

  return (
    <Stack direction="vertical" className="bg-light text-dark d-flex flex-column min-vh-100">
      <VLibras />
      <Header />
      <Routes />
      <Footer />
    </Stack>
  )

}

export default App
